import {
  Conditional,
  DrawerFooter,
  NotificationCatPagination
} from '@cat-ecom/pcc-components';
import { NOTIFICATIONS_DRAWER_PAGE_SIZE } from '../constants';
import { BlocksPageChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import { NotificationsFooterProps } from '../types';
import { NotificationToggle } from '../notification-toggle';

export const NotificationsFooter = ({
  onPageChange,
  currentPage,
  totalResultsCount,
  hidePagination,
  toggleValue,
  setToggleValue
}: NotificationsFooterProps) => {
  const handlePageChange = (e: BlocksPageChangeEvent) => {
    onPageChange(e?.detail.pageNumber);
  };

  return (
    <DrawerFooter className={`d-flex flex-column`}>
      <NotificationToggle
         
        checked={toggleValue}
         
        setToggleValue={setToggleValue}
       
      />
      <Conditional test={!hidePagination}>
        <NotificationCatPagination
          pageSize={NOTIFICATIONS_DRAWER_PAGE_SIZE}
          totalRecords={totalResultsCount}
          currentPage={currentPage}
          className="m-auto"
          handlePageChange={handlePageChange}
        />
      </Conditional>
    </DrawerFooter>
  );
};
